import { ASESORIAS } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null, 
    ventana_filtros: false, 
    filtros: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case ASESORIAS.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case ASESORIAS.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case ASESORIAS.ASESOR:
            return {
                ...state,
                mi_asesor: payload?.asesor || null,
                historial_asesor: payload?.historial || null
            };

        case ASESORIAS.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( joven => joven._id !== payload.id )
            };

        case ASESORIAS.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        case ASESORIAS.ARCHIVOS.LISTAR:
            return {
                detalles: {
                    ...state.detalles, 
                    informacion_asesoria: {
                        ...state.detalles.informacion_asesoria, 
                        archivos: [
                            ...payload
                        ]
                    }
                }
            };

        case ASESORIAS.ARCHIVOS.DETALLES:
            return {
                ...state,
                detalles_archivo: payload
            };

        default:
            return state;
    }
}